import { EndpointBuilder } from '@reduxjs/toolkit/query';
import { GlobalResponse } from '~/models/Commons ';
import { getHeaders } from './Header';


// Generic helper for copy mutations
const buildCopyMutation = <TId extends string | number>(
  builder: EndpointBuilder<any, any, any>,
  basePath: string
) =>
  builder.mutation<GlobalResponse<any>, TId>({
    query: id => {
      const token = sessionStorage.getItem('access_token');
      if (!token) {
        throw new Error('No access token found');
      }

      return {
        url: `${basePath}/${id}/copy`,
        method: 'POST',
        credentials: 'include',
        headers:getHeaders()
      }
    },
  });

export default buildCopyMutation;
